/** Micro-shapes CAGED para el selector de formas (coordenadas en px, caja 24×20). */
export type CagedLetter = "C" | "A" | "G" | "E" | "D";

export const CAGED_CONSTELLATION_DOTS: Record<
  CagedLetter,
  ReadonlyArray<{ top: number; left: number }>
> = {
  C: [
    { top: 14, left: 0 },
    { top: 9, left: 8 },
    { top: 4, left: 16 },
  ],
  A: [
    { top: 9, left: 2 },
    { top: 9, left: 10 },
    { top: 9, left: 18 },
  ],
  G: [
    { top: 2, left: 0 },
    { top: 16, left: 0 },
    { top: 16, left: 18 },
  ],
  E: [
    { top: 5, left: 3 },
    { top: 13, left: 10 },
    { top: 5, left: 17 },
  ],
  D: [
    { top: 13, left: 3 },
    { top: 5, left: 10 },
    { top: 13, left: 17 },
  ],
};

/** Fallback: diagonal genérica para voicings sin letra CAGED. */
export const GENERIC_VOICING_DOTS: ReadonlyArray<{ top: number; left: number }> = [
  { top: 14, left: 2 },
  { top: 9, left: 10 },
  { top: 4, left: 18 },
];

export function parseCagedLetter(shapeName?: string): CagedLetter | null {
  if (!shapeName) return null;
  const shapeMatch = shapeName.match(/Shape\s+([CAGED])\b/i);
  if (shapeMatch) return shapeMatch[1].toUpperCase() as CagedLetter;
  const openMatch = shapeName.match(/^([CAGED])\s*\(/i);
  if (openMatch) return openMatch[1].toUpperCase() as CagedLetter;
  const shortMatch = shapeName.match(/\b([CAGED])\b/);
  if (shortMatch && shapeName.length <= 24) return shortMatch[1].toUpperCase() as CagedLetter;
  return null;
}

export function constellationDotsForShape(shapeName?: string): ReadonlyArray<{ top: number; left: number }> {
  const letter = parseCagedLetter(shapeName);
  if (letter) return CAGED_CONSTELLATION_DOTS[letter];
  return GENERIC_VOICING_DOTS;
}
